

document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("homepage")) {
    // Delegate quantity button clicks
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("plus") || e.target.classList.contains("minus")) {
        const cartForm = e.target.closest(".add-cart");
        if (!cartForm) return;

        const quantityInput = cartForm.querySelector(".product-quantity");
        if (!quantityInput) return;

        let currentValue = parseInt(quantityInput.value, 10) || 1;

        if (e.target.classList.contains("plus")) {
          quantityInput.value = currentValue + 1;
        } else if (e.target.classList.contains("minus") && currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      }
    });

    // Delegate quantity input validation
    document.addEventListener("change", function (e) {
      if (e.target.classList.contains("product-quantity")) {
        if (parseInt(e.target.value) < 1 || isNaN(parseInt(e.target.value))) {
          e.target.value = 1;
        }
      }
    });
  }
});


// Nav-Dropdown
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".has-submenu > .dropdown-arrow").forEach(arrow => {
        arrow.addEventListener("click", function (event) {
            event.stopPropagation();
            let submenu = this.nextElementSibling;
            submenu.style.display = submenu.style.display === "block" ? "none" : "block";
        });
    });
});


// Lable Height Jquery
$(document).ready(function () {
  function setDynamicMinHeight(selector) {
    let maxHeight = 0;
    $(selector).css('min-height', 'auto').each(function () {
      const h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });
  $(selector).css('min-height', maxHeight + 'px');
}


  const selectors = [
    '.product-heading-d .group-block-content .text-block p',
    '.swatches_global',
    '.template-product .product-describe',
    '.recently-viewed-item .product-card-wrapper',
    '.template-404 .resource-list .first_price_gp',
    '.wrap-price-icon-tick',
    '.template-index .product-heading-d .group-block-content .text-block p',
    '#recently-viewed-products .custom-slide a .recent-product-wrap p.product-card-wrapper',
    '.recent-product-wrap p.product-card-wrapper',
    '.template-on-page .price-search .price_wrap_gp',
    '.template-on-page .price-search .first_price_gp',
    '.blog_title h2'
    
  ];

  selectors.forEach(sel => setDynamicMinHeight(sel));

  $(window).resize(function () {
    selectors.forEach(sel => setDynamicMinHeight(sel));
  });
});


// Header-Drawer
$(document).ready(function() {
  // Handle click on expand icon
  $(document).on('click', '.menu-expand-trigger', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Close any other open menus first
    $('details').removeAttr('open');
    
    // Open this menu
    $(this).closest('details').attr('open', 'open');
  });
  
  // Handle back button
  $(document).on('click', '.menu-drawer__back-button', function(e) {
    e.preventDefault();
    $(this).closest('details').removeAttr('open');
  });
  
  // Close all menus when clicking the main close button
  $('.menu-drawer__close-button').on('click', function() {
    $('details').removeAttr('open');
  });
});


$(document).ready(function () {
  $('.ashish-slider-wrapper').each(function () {
    let $wrapper = $(this);
    let $track = $wrapper.find('.ashish-slider-track');

    if ($track.children().length === 0) {
      $wrapper.addClass('hidden-slider'); // add your custom class
    }
  });
});

$(document).ready(function () {
  $('.ashish-slider-wrapper').each(function () {
    const $wrapper = $(this);
    const $track = $wrapper.find('.ashish-slider-track');
    const $slides = $track.children();

    // 👉 If less than 6 slides, add no-padding class
    if ($slides.length < 6) {
      $wrapper.addClass('no-padding');
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  // First, check if there's a "Detecting location..." text in any location-text element and set a default
  document.querySelectorAll('.location-text').forEach(locText => {
    if (locText.textContent === 'Detecting location...' || !locText.textContent.trim()) {
      // Find the first available location from any dropdown
      const firstLocationItem = document.querySelector('li[data-location]');
      if (firstLocationItem) {
        const defaultLocation = firstLocationItem.getAttribute('data-location');
        locText.textContent = defaultLocation;
      } else {
        // Fallback to a hardcoded default if no locations found
        locText.textContent = 'Concord';
      }
    }
  });

  // Loop through each header-phone instance (both desktop and mobile)
  document.querySelectorAll('.header-phone, .header-phone-mobile, .mobile-accordion-store-location-structure').forEach(header => {
    // For mobile accordion structure, the dropdown is the element itself
    const dropdown = header.classList.contains('mobile-accordion-store-location-structure') 
      ? header 
      : header.querySelector('.phone-dropdown');
    
    if (!dropdown) return; // safety

    const items = dropdown.querySelectorAll('li[data-location]');
    if (items.length === 0) return; // skip if no location items found
    
    const locationText = header.classList.contains('mobile-accordion-store-location-structure')
      ? document.querySelector('.location-text') // For mobile, we need to find the global location text
      : header.querySelector('.location-text');
      
    const caret = header.querySelector('.location-flex span');
    const crossBtn = dropdown.querySelector('.cross-flex svg');
    const searchInput = dropdown.querySelector('.input-put-text');

    // --- Update city and phone display ---
    function updateLocationUI(cityText, phone = "") {
      const validCities = ['Concord', 'Burlington'];
      if (!validCities.includes(cityText)) {
        cityText = 'Concord';
      }
      if (locationText) {
        locationText.textContent = cityText;
      }
      if (phone) {
        const phoneEl = header.querySelector('.location-phone');
        if (phoneEl) phoneEl.textContent = phone;
      }
      
      // Update selected state in dropdown
      items.forEach(item => {
        const itemLocation = item.getAttribute('data-location');
        if (itemLocation && itemLocation.includes(cityText)) {
          item.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
        } else {
          item.style.backgroundColor = '';
        }
      });
    }

    // --- Get city from coordinates (GPS) ---
    function getCityFromCoords(lat, lon) {
      fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`)
        .then(res => res.json())
        .then(data => {
          if (data.city) {
            findAndSelectMatchingLocation(data.city);
          } else {
            getCityFromIP();
          }
        })
        .catch(() => getCityFromIP());
    }

    // --- Fallback if GPS fails — default location (ipapi.co CORS-blocked) ---
    function getCityFromIP() {
      // v7.6: ipapi.co CORS-fails from storefront. Default to first location.
      selectDefaultLocation();
    }
    
    // --- Find and select matching location from available locations ---
    function findAndSelectMatchingLocation(cityName) {
      // Convert to lowercase for case-insensitive comparison
      const lowerCityName = cityName.toLowerCase();
      
      // Try to find a matching location in our list
      let matchFound = false;
      
      for (const item of items) {
        const itemLocation = item.getAttribute('data-location');
        if (itemLocation && itemLocation.toLowerCase().includes(lowerCityName)) {
          // Found a match, update UI with this location
          const phone = item.getAttribute('data-phone');
          updateLocationUI(itemLocation, phone);
          matchFound = true;
          break;
        }
      }
      
      // If no match found, select default location
      if (!matchFound) {
        selectDefaultLocation();
      }
    }
    
    // --- Select the first location as default ---
    function selectDefaultLocation() {
      if (items.length > 0) {
        const firstItem = items[0];
        const defaultLocation = firstItem.getAttribute('data-location');
        const defaultPhone = firstItem.getAttribute('data-phone');
        updateLocationUI(defaultLocation, defaultPhone);
      }
    }

    // --- Start detection (only once globally, not per header) ---
    if (!window.locationDetectionStarted) {
      window.locationDetectionStarted = true;
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          pos => getCityFromCoords(pos.coords.latitude, pos.coords.longitude),
          err => getCityFromIP()
        );
      } else {
        getCityFromIP();
      }
    }

    // --- Manual location selection via dropdown ---
    items.forEach(item => {
      item.addEventListener('click', e => {
        const phone = item.getAttribute('data-phone');
        // Get the location directly from data-location attribute
        const location = item.getAttribute('data-location');
        // Update UI with the exact location from the data attribute
        updateLocationUI(location, phone);
        
        // Close the dropdown after selection - different handling for mobile vs desktop
        if (header.classList.contains('mobile-accordion-store-location-structure')) {
          // For mobile, we need to handle multiple potential drawer implementations
          
          // Handle menu-drawer from header-drawer.liquid
          const menuDrawerContainer = document.querySelector('.menu-drawer-container');
          if (menuDrawerContainer) {
            const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
            if (menuDrawerDetails && menuDrawerDetails.hasAttribute('open')) {
              menuDrawerDetails.removeAttribute('open');
            }
            document.body.classList.remove('menu-open');
            document.body.classList.remove('overflow-hidden');
          }
          
          // Handle any other mobile drawer implementations
          const mobileDrawers = document.querySelectorAll('.drawer-menu, .menu-drawer, .mobile-menu-drawer');
          mobileDrawers.forEach(drawer => {
            drawer.classList.remove('active', 'open');
          });
          
          // If there's a body class that controls the drawer
          document.body.classList.remove('drawer-open', 'mobile-menu-active');
          
          // Close any open details elements that might be part of the mobile UI
          const mobileDetails = document.querySelectorAll('details[open]');
          mobileDetails.forEach(detail => {
            if (detail.id !== 'Details-menu-drawer-container') {
              detail.removeAttribute('open');
            }
          });
          
          // Clear search input if it exists
          if (searchInput) {
            searchInput.value = '';
            // Reset visibility of all items
            items.forEach(i => {
              i.style.display = '';
            });
            
            // Hide the no matches message if it exists
            const noMatchesMessage = dropdown.querySelector('.no-matches-message');
            if (noMatchesMessage) {
              noMatchesMessage.style.display = 'none';
            }
          }
        } else {
          // Standard dropdown closing for desktop
          dropdown.style.display = 'none';
        }
        
        e.stopPropagation();
      });
    });

    // --- Toggle dropdown open/close ---
    header.addEventListener('click', e => {
      dropdown.style.display = 'block'; // always open
      e.stopPropagation();
    });

    if (caret) {
      caret.addEventListener('click', e => {
        dropdown.style.display = 'block'; // always open
        e.stopPropagation();
      });
    }

    if (crossBtn) {
      crossBtn.addEventListener('click', e => {
        dropdown.style.display = 'none';
        e.stopPropagation();
      });
    }
    
    // --- Search functionality for locations ---
    if (searchInput) {
      // Filter function that can be reused for both desktop and mobile
      const filterLocations = (searchTerm) => {
        // Filter the location items based on search term
        let matchFound = false;
        
        items.forEach(item => {
          const locationText = item.getAttribute('data-location') || '';
          const addressText = item.textContent.trim().toLowerCase();
          
          // Check if either the location name or the full address contains the search term
          if (locationText.toLowerCase().includes(searchTerm) || addressText.includes(searchTerm)) {
            item.style.display = ''; // Show the item
            matchFound = true;
          } else {
            item.style.display = 'none'; // Hide the item
          }
        });
        
        // Handle no matches message
        let noMatchesMessage = dropdown.querySelector('.no-matches-message');
        
        // If no message element exists, create one
        if (!noMatchesMessage) {
          noMatchesMessage = document.createElement('div');
          noMatchesMessage.className = 'no-matches-message';
          noMatchesMessage.style.padding = '15px';
          noMatchesMessage.style.textAlign = 'center';
          noMatchesMessage.style.color = '#666';
          noMatchesMessage.style.fontStyle = 'italic';
          
          // Find the right place to insert the message
          const listContainer = dropdown.querySelector('.wrap-li-accordion-address') || dropdown;
          listContainer.appendChild(noMatchesMessage);
        }
        
        // Show or hide the message based on search results
        if (!matchFound && searchTerm.length > 0) {
          noMatchesMessage.textContent = 'No locations matching "' + searchTerm + '"';
          noMatchesMessage.style.display = 'block';
        } else {
          noMatchesMessage.style.display = 'none';
        }
      };
      
      // Add input event listener
      searchInput.addEventListener('input', e => {
        const searchTerm = e.target.value.toLowerCase().trim();
        filterLocations(searchTerm);
      });
      
      // Special handling for mobile search button if it exists
      const searchButton = dropdown.querySelector('.search-icon-svg');
      if (searchButton) {
        searchButton.addEventListener('click', () => {
          const searchTerm = searchInput.value.toLowerCase().trim();
          filterLocations(searchTerm);
        });
      }
      
      // Handle "Locate Me" button if it exists
      const locateButton = dropdown.querySelector('.locate-button');
      if (locateButton) {
        locateButton.addEventListener('click', () => {
          // Show a loading indicator in the search input
          if (searchInput) {
            searchInput.value = 'Finding your location...';
            searchInput.disabled = true;
          }
          
          // Update the location text in the header to show we're detecting location
          // But only if it's not already set to something else
          const allLocationTexts = document.querySelectorAll('.location-text');
          allLocationTexts.forEach(locText => {
            // Store the original text to restore if detection fails
            const originalText = locText.textContent;
            locText.setAttribute('data-original-text', originalText);
            
            // Only change if it's not already in detecting state
            if (locText.textContent !== 'Detecting location...') {
              locText.textContent = 'Detecting...';
            }
          });
          
          // Set a timeout to ensure we don't get stuck
          const locationTimeout = setTimeout(() => {
            console.log('Location detection timed out, using default location');
            resetSearchAndSelectDefault();
            
            // Restore original location text if detection failed
            allLocationTexts.forEach(locText => {
              const originalText = locText.getAttribute('data-original-text');
              if (originalText) {
                locText.textContent = originalText;
              }
            });
          }, 5000); // 5 second timeout
          
          if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
              pos => {
                clearTimeout(locationTimeout);
                // Get city from coordinates
                fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${pos.coords.latitude}&longitude=${pos.coords.longitude}&localityLanguage=en`)
                  .then(res => res.json())
                  .then(data => {
                    if (data && data.city) {
                      console.log('Location found via GPS:', data.city);
                      // Update the search input with the found city
                      if (searchInput) {
                        searchInput.value = data.city;
                        searchInput.disabled = false;
                        
                        // Trigger the search with the found city
                        filterLocations(data.city.toLowerCase());
                      }
                      findAndSelectMatchingLocation(data.city);
                    } else {
                      console.log('No city found in GPS data, trying IP');
                      getCityFromIPAndSearch();
                    }
                  })
                  .catch(error => {
                    console.log('Error getting location from GPS:', error);
                    getCityFromIPAndSearch();
                  });
              },
              err => {
                console.log('GPS error:', err.message);
                clearTimeout(locationTimeout);
                getCityFromIPAndSearch();
              },
              { timeout: 3000, maximumAge: 60000 } // 3 second timeout for GPS
            );
          } else {
            clearTimeout(locationTimeout);
            getCityFromIPAndSearch();
          }
        });
      }
      
      // v7.6: ipapi.co CORS-fails from storefront. Default to first location.
      function getCityFromIPAndSearch() {
        resetSearchAndSelectDefault();
      }
      
      // Reset search and select default location
      function resetSearchAndSelectDefault() {
        // Reset search input if no city found
        if (searchInput) {
          searchInput.value = '';
          searchInput.disabled = false;
        }
        
        // Select default location (first in list)
        if (items.length > 0) {
          const firstItem = items[0];
          const defaultLocation = firstItem.getAttribute('data-location');
          const defaultPhone = firstItem.getAttribute('data-phone');
          
          console.log('Using default location:', defaultLocation);
          
          // Update UI with default location
          updateLocationUI(defaultLocation, defaultPhone);
          
          // Update ALL location text elements across the site to ensure consistency
          document.querySelectorAll('.location-text').forEach(locText => {
            if (locText.textContent === 'Detecting location...' || 
                locText.textContent === 'Detecting...' ||
                !locText.textContent.trim()) {
              locText.textContent = defaultLocation;
            }
          });
          
          // Show all items
          items.forEach(item => {
            item.style.display = '';
          });
          
          // Hide no matches message if it exists
          const noMatchesMessage = dropdown.querySelector('.no-matches-message');
          if (noMatchesMessage) {
            noMatchesMessage.style.display = 'none';
          }
        }
      }
      
      // Clear search when dropdown closes
      document.addEventListener('click', () => {
        // For desktop dropdown
        if (!header.classList.contains('mobile-accordion-store-location-structure') && 
            dropdown.style.display === 'none') {
          searchInput.value = '';
          // Show all items when search is cleared
          items.forEach(item => {
            item.style.display = '';
          });
          
          // Hide the no matches message if it exists
          const noMatchesMessage = dropdown.querySelector('.no-matches-message');
          if (noMatchesMessage) {
            noMatchesMessage.style.display = 'none';
          }
        }
      });
      
      // For mobile, add a specific handler for the cross button
      if (crossBtn && header.classList.contains('mobile-accordion-store-location-structure')) {
        crossBtn.addEventListener('click', () => {
          searchInput.value = '';
          // Show all items when search is cleared
          items.forEach(item => {
            item.style.display = '';
          });
        });
      }
    }
  });
});



// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.accordion-structure-store-locator svg').forEach(svg => {
//     svg.addEventListener('click', e => {
//       e.stopPropagation();
//       const accordion = svg.closest('.accordion-structure-store-locator');
//       const phoneDiv = accordion.parentElement.querySelector('.phone-div-structure');

//       // Close all open ones first
//       document.querySelectorAll('.accordion-structure-store-locator.active').forEach(activeAccordion => {
//         activeAccordion.classList.remove('active');
//         const activePhoneDiv = activeAccordion.parentElement.querySelector('.phone-div-structure');
//         if (activePhoneDiv) activePhoneDiv.style.display = 'none';
//       });

//       // If the clicked one was already active, stop here (prevents re-opening instantly)
//       if (accordion.classList.contains('active')) {
//         return;
//       }

//       // Open the clicked one
//       phoneDiv.style.display = 'block';
//       accordion.classList.add('active');
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  // Close all accordions on page load
  document.querySelectorAll('.accordion-structure-store-locator').forEach(accordion => {
    accordion.classList.remove('active');
    const phoneDiv = accordion.parentElement.querySelector('.phone-div-structure');
    if (phoneDiv) phoneDiv.style.display = 'none';
  });

  // Click event on arrow SVGs
  document.querySelectorAll('.accordion-structure-store-locator svg').forEach(svg => {
    svg.addEventListener('click', e => {
      e.stopPropagation();
      const accordion = svg.closest('.accordion-structure-store-locator');
      const phoneDiv = accordion.parentElement.querySelector('.phone-div-structure');

      if (!phoneDiv) return;

      // Close all other accordions
      document.querySelectorAll('.accordion-structure-store-locator.active').forEach(activeAccordion => {
        if (activeAccordion !== accordion) {
          activeAccordion.classList.remove('active');
          const activePhoneDiv = activeAccordion.parentElement.querySelector('.phone-div-structure');
          if (activePhoneDiv) activePhoneDiv.style.display = 'none';
        }
      });

      // Toggle the clicked one based on display
      if (phoneDiv.style.display === 'none' || phoneDiv.style.display === '') {
        phoneDiv.style.display = 'block';
        accordion.classList.add('active');
      } else {
        phoneDiv.style.display = 'none';
        accordion.classList.remove('active');
      }
    });
  });
});





// $(document).ready(function () {
//   // Step 1: Add active class to the first li + its .accordion-structure-store-locator in every wrapper
//   $('.wrap-li-accordion-address').each(function () {
//     let $firstLi = $(this).find('li').first();
//     $firstLi.addClass('active');
//     $firstLi.find('.accordion-structure-store-locator').addClass('active');
//   });

//   // Step 2: Handle click on li
//   $(document).on('click', '.wrap-li-accordion-address li', function () {
//     let $wrapper = $(this).closest('.wrap-li-accordion-address');

//     // Remove active from all li + their .accordion-structure-store-locator in this wrapper
//     $wrapper.find('li').removeClass('active');
//     $wrapper.find('.accordion-structure-store-locator').removeClass('active');

//     // Add active only to clicked li + its .accordion-structure-store-locator
//     $(this).addClass('active');
//     $(this).find('.accordion-structure-store-locator').addClass('active');
//   });
// });

$(document).ready(function () {
  // Step 1: Hide all phone divs and remove active class on load
  $('.phone-div-structure').hide();
  $('.accordion-structure-store-locator').removeClass('active');

  // Step 2: Handle click on arrow-icon
  $(document).on('click', '.arrow-icon', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $accordion = $(this).closest('.accordion-structure-store-locator');
    var $wrapper = $accordion.closest('.location-padding.location-size');
    var $phoneDiv = $wrapper.children('.phone-div-structure');

    // Close all other accordions
    $('.accordion-structure-store-locator.active').each(function() {
      if (this !== $accordion[0]) { // Skip clicked one
        $(this).removeClass('active');
        $(this).parent().children('.phone-div-structure').hide();
      }
    });

    // Open clicked one if not already active
    if (!$accordion.hasClass('active')) {
      $accordion.addClass('active');
      $phoneDiv.show();
    }
  });
});



$(document).ready(function () {
  // 1) Add class if top-level menu has more than 6 <li>
  $(".mega-menu__list").each(function () {
    if ($(this).children("li").length > 6) {
      $(this).addClass("menu-has-more-than-6");
    }
  });

  // 2) Add class to submenu if parent has more than 6 children
  $(".menu-list__submenu").each(function () {
    if ($(this).children("li").length > 6) {
      $(this).addClass("more-than-parent-6");
    }
  });
});












